import { getRootNodeId } from 'common/entities/form/selectors';
import { NODE_TYPE_GROUP } from 'common/entities/formNode/nodeTypes';
import { getFormNode } from 'common/entities/formNode/selectors';

import { getFormId } from '../selectors';

import {
    UPDATE_FORM_NODE_LOGIC,
    REMOVE_FORM_NODE_LOGIC,
    ADD_NODE_LOGIC_TO_FORM_NODE,
    REMOVE_NODE_LOGIC_FROM_FORM_NODE,
    ADD_FORM_NODE_LOGIC,
    SET_REQUIRED,
} from '../constants/actionTypes';

import { applyCallbackToNodeWithAdditionalGuestsSupport } from './nodeActions';

export const addFormNodeLogicAction = (payload) => ({
    type: ADD_FORM_NODE_LOGIC,
    payload,
});

export const removeFormNodeLogicAction = (payload) => ({
    type: REMOVE_FORM_NODE_LOGIC,
    payload,
});

export const updateFormNodeLogicAction = (payload) => ({
    type: UPDATE_FORM_NODE_LOGIC,
    payload,
});

export const addFormNodeLogicToFormNodeAction = ({ formNodeId, logicRuleIds }) => ({
    type: ADD_NODE_LOGIC_TO_FORM_NODE,
    payload: {
        formNodeId,
        logicRuleIds,
    },
});

export const removeFormNodeLogicToFormNodeAction = ({ logicRuleIds }) => ({
    type: REMOVE_NODE_LOGIC_FROM_FORM_NODE,
    payload: {
        logicRuleIds,
    },
});

// /////////////////////////////////////////////////////////////////////////////////////////////////
// Thunks
// ⬇️⬇️⬇️⬇️⬇️⬇️
// /////////////////////////////////////////////////////////////////////////////////////////////////
/**
 * @param {string} targetNodeId
 * @param {bool} isRequired
 */
export const setRequiredFormNodeLogicNode = (targetNodeId, isRequired) => (dispatch, getState) => {
    const state = getState();
    const formId = getFormId(state);
    const rootNodeId = getRootNodeId(state, formId);

    applyCallbackToNodeWithAdditionalGuestsSupport(
        state,
        targetNodeId,
    )((node) =>
        dispatch({
            type: SET_REQUIRED,
            targetNodeId: node.id,
            rootNodeId,
            isRequired,
        }),
    );
};

/**
 * @param {string} targetNodeId
 * @param {bool} isRequired
 */
export const setRequiredFormNodeLogic = (targetNodeId, isRequired) => (dispatch, getState) => {
    const state = getState();
    const { type, children } = getFormNode(state, targetNodeId);

    if (type === NODE_TYPE_GROUP) {
        children.forEach((nodeId) => dispatch(setRequiredFormNodeLogic(nodeId, isRequired)));
        return;
    }

    dispatch(setRequiredFormNodeLogicNode(targetNodeId, isRequired));
};
